export default __webpack_public_path__ + "static/media/menu_close.291d8d97.svg";